import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  HostBinding, OnChanges, SimpleChanges,
} from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'con-file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FileListComponent implements OnInit , OnChanges{
  @HostBinding('class') class = 'con-file-list';

  @Input() files: any[] = [];
  @Input() listType = 'image';
  @Input() showAddButton = true;
  @Output() addFile = new EventEmitter<void>();
  @Output() removeFile = new EventEmitter<string>();
  checkUrl = false;
  constructor() {}
  ngOnInit() {
    this.checkUrl = window.location.href.includes('products');
    if( window.location.href.includes('distributors')){
      this.checkUrl = false;
    }
  }
  ngOnChanges(changes: SimpleChanges) {
  }
}
